<template>
	<AlertCardWrapper @action-button-click="reconnectProfile" :actionTitle="actionTitle" :titleArr="titleArr" :alert="alert">
		<template #subtitle>
			<SubTitle
				:hideIcon="hideIcon"
				:text="subtitleText"
				:icon="subtitleIcon"
				:iconType="subtitleIconType"
				:linkText="subTitleLinkText"
				@subtitle-link-click="onSubTitleLinkClick"
			/>
			<AddProfile v-bind="addProfileBindData" ref="profileManager" v-if="needAction && relatedCredentialsApp" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import { buildProfileObj } from '@/utils/helpers';
import { pluralize } from '@/utils/language-service';
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import { getWorkflowData } from '@/store/modules/workflows/actions';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { getService, getServiceBySlug } from '@/store/modules/apps/getters';
import { mapActions, mapGetters } from 'vuex';
import { getAccountConnection } from '@/store/modules/credentials/getters';
import { getUserCredentials, getCredentialData } from '@/store/modules/credentials/actions';
import { appURL, appApiURL } from '@/store/modules/main/getters';
import WorkflowService from '@/utils/WorkflowService';
import AppService from '@/utils/AppService';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ReconnectCredentials',
	mixins: [AlertTypeBaseMixin],
	computed: {
		...mapGetters([getWorkflow.fullPath, getAccountConnection.fullPath, getService.fullPath, appURL.fullPath, appApiURL.fullPath]),
		...mapGettersShorthand({ getServiceBySlug }),
		relatedModules() {
			return this.relatedEntitiesMapByEntityType.workflow || [];
		},
		relatedUsers() {
			return this.relatedEntitiesMapByEntityType.user || [];
		},
		actionTitle() {
			return 'Reconnect';
		},
		titleArr() {
			const numOfRelatedModules = this.relatedModules.length;
			const numOfRelatedUsers = this.relatedUsers.length;
			return [
				{ text: `${numOfRelatedModules} ${pluralize('feature', numOfRelatedModules)}`, isBold: true },
				{ text: 'turned off due to lost access to your' },
				{ text: this.relatedCredentialsApp?.service_name, isBold: true },
				{ text: 'account' },
				{ text: numOfRelatedUsers > 0 ? `(affecting ${numOfRelatedUsers} ${pluralize('user', numOfRelatedUsers)})` : '', isBold: true },
			];
		},
		mainRelatedModule() {
			if (this.relatedModules.length > 0) {
				return this[getWorkflow.fullPath](this.relatedModules[0]);
			}
			return null;
		},
		mainRelatedModuleContextService() {
			const serviceContextSlug = WorkflowService.getWorkflowContextServiceSlug(this.mainRelatedModule);
			return this.getServiceBySlug(serviceContextSlug);
		},
		subtitleText() {
			return this.mainRelatedModule?.workflow_title || '';
		},
		subtitleIcon() {
			return AppService.getIntegrationName(this.mainRelatedModuleContextService);
		},
		subtitleIconType() {
			return this.mainRelatedModule?.flow_type;
		},
		subTitleLinkText() {
			const othersRelatedModulesNum = this.relatedModules.length - 1;
			return othersRelatedModulesNum > 0 ? `+${othersRelatedModulesNum} ${pluralize('other', othersRelatedModulesNum)}` : '';
		},
		relatedCredentialsApp() {
			const creds = this[getAccountConnection.fullPath](this.alert.entity_id);
			const app = this[getService.fullPath](creds?.service);
			return app;
		},
		addProfileBindData() {
			return this.relatedCredentialsApp ? buildProfileObj(this.relatedCredentialsApp) : {};
		},
	},
	methods: {
		...mapActions([getWorkflowData.fullPath, getUserCredentials.fullPath, getCredentialData.fullPath]),
		onSubTitleLinkClick() {
			console.log('onSubTitleLinkClick');
		},
		getRelatedEntities() {
			this.relatedModules.forEach((moduleId) => this[getWorkflowData.fullPath]({ id: moduleId }));
		},
		reconnectProfile() {
			this.$nextTick(() => {
				this.$refs.profileManager.startAddProfile({
					credsID: this.alert.entity_id,
					app: this.relatedCredentialsApp,
					apiURL: this[appApiURL.fullPath],
					appURL: this[appURL.fullPath],
					getAppProfiles: this.getAppProfiles,
				});
			});
		},
		getAppProfiles() {
			this[getUserCredentials.fullPath]({ forceGet: true });
		},
		async getConnectionIfNotSet() {
			await this[getCredentialData.fullPath]({ id: this.alert.entity_id });
		},
	},
	async mounted() {
		this.getRelatedEntities();
		await this.getConnectionIfNotSet();
	},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss"></style>
